import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { OrderProvider } from './context/OrderContext';
import { ThemeProvider } from '@mui/material/styles'; // Import ThemeProvider
import theme from './theme'; // Import the custom theme
import '@fontsource/poppins'; // Import Poppins font

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <OrderProvider>
      <ThemeProvider theme={theme}> {/* Wrap your app with ThemeProvider */}
        <App />
      </ThemeProvider>
    </OrderProvider>
  </Router>
);
